import React from 'react'
import EventContainer from './EventContainer'
import FacebookButton from './FacebookButton'
import TwitterButton from './TwitterButton'
import WhatsappButton from './WhatsappButton'
import TelegramButton from './TelegramButton'
import EmailButton from './EmailButton'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { makeTitle } from '../../services/services'

const EventsContainer = styled.div``

export default function ShareBody(props) {
  const { event } = props
  return (
    <EventsContainer className=" px-5 pb-4">
      <EventContainer event={event} makeTitle={makeTitle} />
      <FacebookButton event={event} makeTitle={makeTitle} />
      <TwitterButton event={event} makeTitle={makeTitle} />
      <WhatsappButton event={event} makeTitle={makeTitle} />
      <TelegramButton event={event} makeTitle={makeTitle} />
      <EmailButton event={event} makeTitle={makeTitle} />
    </EventsContainer>
  )
}

ShareBody.propTypes = {
  event: PropTypes.object,
}
